import { render, staticRenderFns } from "./CardItemBase.vue?vue&type=template&id=2031fa5a&scoped=true&"
import script from "./CardItemBase.vue?vue&type=script&lang=js&"
export * from "./CardItemBase.vue?vue&type=script&lang=js&"
import style0 from "./CardItemBase.vue?vue&type=style&index=0&id=2031fa5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2031fa5a",
  null
  
)

export default component.exports